module.exports = __webpack_public_path__ + "img/room.50bab3b9.png";